import { render, staticRenderFns } from "./DodCustomTextarea.vue?vue&type=template&id=521edb8a&scoped=true&"
import script from "./DodCustomTextarea.vue?vue&type=script&lang=js&"
export * from "./DodCustomTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomTextarea.vue?vue&type=style&index=0&id=521edb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521edb8a",
  null
  
)

export default component.exports